/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Dialog_EyebrowInputs */

const es_landing_dialog_eyebrow = /** @type {(inputs: Landing_Dialog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu anuncio, tus reglas`)
};

const gl_landing_dialog_eyebrow = /** @type {(inputs: Landing_Dialog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu anuncio, as túas regras`)
};

const en_landing_dialog_eyebrow = /** @type {(inputs: Landing_Dialog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing, your rules`)
};

/**
* | output |
* | --- |
* | "Your listing, your rules" |
*
* @param {Landing_Dialog_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_dialog_eyebrow = /** @type {((inputs?: Landing_Dialog_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Dialog_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_dialog_eyebrow(inputs)
	if (locale === "en") return en_landing_dialog_eyebrow(inputs)
	return es_landing_dialog_eyebrow(inputs)
});